// extracted by mini-css-extract-plugin
export default {"sendMessageField":"styles_sendMessageField__TRMie","textarea":"styles_textarea__djgFF","button":"styles_button__z9VFW"};